// extracted by mini-css-extract-plugin
module.exports = {"root":"search-icon-button_root__Mqno1"};